import React, { useContext } from 'react';
import AppLayoutFooter from './components/AppLayoutFooter';
import AppLayoutHeader from './components/AppLayoutHeader';
import AppLayoutSidebar from './components/AppLayoutSidebar';
import Loading from './components/Loading';
import Modals from './components/Modals';
import { AppLayoutContainer, AppLayoutContent, AppLayoutContentContainer } from './style';
import AppContext from 'src/contexts/AppContext';
import AppContextProvider from 'src/components/AppContextProvider';
import LoadingContextProvider from 'src/components/LoadingContextProvider';
import ModalContextProvider from 'src/components/ModalContextProvider';
import SearchContextProvider from 'src/components/SearchContextProvider';
import SidebarContextProvider from 'src/components/SidebarContextProvider';
import SpecialtyCreationContextProvider from 'src/components/SpecialtyCreationContextProvider';
import ThemeCreationContextProvider from 'src/components/ThemeCreationContextProvider';

const AppLayoutContentWrapper: React.FC = ({ children }) => {
  const { setShowUserContextMenu } = useContext(AppContext);

  const hideUserContextMenu = () => {
    setShowUserContextMenu(false);
  };

  return (
    <AppLayoutContentContainer onClick={hideUserContextMenu}>
      {children}
    </AppLayoutContentContainer>
  );
};

const AppLayout: React.FC = ({ children }) => {
  return (
    <ModalContextProvider>
      <SidebarContextProvider>
        <SearchContextProvider>
          <LoadingContextProvider>
            <SpecialtyCreationContextProvider>
              <ThemeCreationContextProvider>
                <AppContextProvider>
                  <AppLayoutContainer>
                    <AppLayoutSidebar />
                    <AppLayoutContentWrapper>
                      <AppLayoutHeader />
                      <AppLayoutContent>{children}</AppLayoutContent>
                      <AppLayoutFooter />
                    </AppLayoutContentWrapper>
                    <Modals />
                  </AppLayoutContainer>
                  <Loading />
                </AppContextProvider>
              </ThemeCreationContextProvider>
            </SpecialtyCreationContextProvider>
          </LoadingContextProvider>
        </SearchContextProvider>
      </SidebarContextProvider>
    </ModalContextProvider>
  );
};

export default AppLayout;
